import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader, EmptyState, relativeTime } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Bell, AlertTriangle, Thermometer, ClipboardCheck, ShoppingCart, CheckCheck, SprayCan, ListChecks } from "lucide-react";

const ICONS = {
  temperature_exception: AlertTriangle, checklist_missed: ClipboardCheck, order_failed: ShoppingCart,
  cleaning_assigned: SprayCan, cleaning_reassigned: SprayCan, cleaning_unassigned: SprayCan,
  prep_assigned: ListChecks, prep_reassigned: ListChecks, prep_unassigned: ListChecks,
  default: Thermometer,
};

export default function Notifications() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  const load = async () => setItems((await api.get("/notifications")).data);
  useEffect(() => { load(); }, []);

  const open = async (n) => { if (!n.read) await api.post(`/notifications/${n.notification_id}/read`); if (n.link) navigate(n.link); else load(); };

  return (
    <div>
      <PageHeader title="Notifications" subtitle="Alerts, reminders and management flags." testid="notifications-header"
        action={items.some((n) => !n.read) && <Button variant="outline" className="rounded-xl" data-testid="mark-all-read" onClick={async () => { await api.post("/notifications/read-all"); load(); }}><CheckCheck size={16} className="mr-1" /> Mark all read</Button>} />

      {items.length === 0 ? <EmptyState icon={Bell} title="You're all caught up." message="No notifications right now." /> :
        <div className="space-y-2" data-testid="notifications-list">
          {items.map((n) => {
            const Icon = ICONS[n.type] || ICONS.default;
            const danger = n.type.includes("exception") || n.type.includes("failed") || n.type.includes("missed");
            return (
              <div key={n.notification_id} onClick={() => open(n)} data-testid={`notification-${n.notification_id}`}
                className={`cc-card p-4 flex items-start gap-3 cursor-pointer hover:shadow-md transition-all ${!n.read ? "border-l-4 border-l-brand" : ""}`}>
                <div className={`h-10 w-10 rounded-xl flex items-center justify-center shrink-0 ${danger ? "bg-red-100 text-red-600" : "bg-brand-light text-brand-dark"}`}><Icon size={18} /></div>
                <div className="flex-1 min-w-0">
                  <div className="font-semibold text-slate-800 text-sm">{n.title}</div>
                  <div className="text-sm text-slate-600">{n.message}</div>
                  <div className="text-[11px] text-slate-400 mt-0.5">{relativeTime(n.created_at)}</div>
                </div>
                {!n.read && <span className="h-2.5 w-2.5 rounded-full bg-brand shrink-0 mt-1" />}
              </div>
            );
          })}
        </div>}
    </div>
  );
}
